import {property} from '@wonderlandengine/api/decorators.js';
import {SoundManagerInstance, Sounds} from '../../managers/soundmanager.js';
import {ActionBase} from './action-base.js';
import {Object3D} from '@wonderlandengine/api';

/**
 * General and reusable action.
 * This action is used to enable an object when the trigger is activated.
 */
export class ActionEnable extends ActionBase {
    static TypeName = 'action-enable';

    /**
     * The name of the sound to play.
     * Must be a sound that is loaded in the SoundManager.
     */
    @property.object()
    targetObject?: Object3D;

    /**
     * Play the audio only once. Even if the trigger is activated multiple times.
     */
    @property.bool(false)
    enableOnce = false;

    private isEnabled = false;

    OnTrigger() {
        if (this.enableOnce && this.isEnabled) {
            return;
        }

        this.targetObject!.active = true;
        this.targetObject?.getComponents().forEach((component) => {
            component.active = true;
        });

        this.isEnabled = true;
    }
}
